import { render, staticRenderFns } from "./CostTable.vue?vue&type=template&id=72996e04&scoped=true&"
import script from "./CostTable.vue?vue&type=script&lang=js&"
export * from "./CostTable.vue?vue&type=script&lang=js&"
import style0 from "./CostTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CostTable.vue?vue&type=style&index=1&id=72996e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72996e04",
  null
  
)

export default component.exports